/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import gql from 'graphql-tag';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 * @param {array} arrPartNumbers - array of SKU's to be fetched
 * @param {string} fields - fields to be queried
 */
const fetchedField = `
        id
        brandId
        is3dEnabled
    image {
        additionalImages
        altText
        name
        path
        snipe
        snipeImagePath
        snipeProductEndDate
        snipeCategoryEndDate
        snipeProductStartDate
        snipeCategoryStartDate
        collectionImage
        __typename
    }
    productType
    reviews
    partNumber
    baseCode
    prices {
        currency
        type
        value
        __typename
    }
    skuPriceRange {
        sale {
            value
        }
        retail {
            value
        }
        __typename
    }
    name
    brand
    seo {
        url
        __typename

    }
    productSkus {
        marketplaceShopName
        partNumber
        id
        __typename
    }
    isPassportEligible
    isPersonalizable
    availability {
        availabilityIndicator
        deliveryDateType
        displayEndDate
        displayStartDate
        earliestShipDate
        latestShipDate
        perishable
        productDeliveryType
        shipAlone
        deliveryMessage
        __typename
    }
`;
const findProductByPartNumbers = (brand, arrPartNumbers, fields = fetchedField) => {
    if (!arrPartNumbers || !Array.isArray(arrPartNumbers)) {
        console.error('findProductsByPartNumbers did not recieve valid partNumbers. partNumbers recieved:', arrPartNumbers);
        return null;
    }
    const partNumbers = `["${arrPartNumbers.join('","')}"]`;
    return (gql`{ findProductByPartNumbers(brand: "${brand}", environment: "${GRAPHQL_ENV}", partNumbers: ${partNumbers}) {
            ${fields}
            __typename
        }
    }`);
};

export default findProductByPartNumbers;
